import { styled } from '@mui/material/styles';
import { TableRow } from '@mui/material';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor:
      theme.palette.mode === 'light'
        ? theme.palette.grey[100]
        : theme.palette.action.selected,
  },
}));

export default StyledTableRow;
